import ServerUtils from '@root/core/src/api/server-utils';

export async function validateToken() {
  const { data } = await ServerUtils.authenticatedGet('/web_api/login/validate_token');
  return data;
}

export async function emailFromToken(emailToken) {
  const { data } = await ServerUtils.unauthenticatedGet('/web_api/user_email_token', {
    expectedResponse: 200,
    query: {
      emailToken,
    },
  });
  return data;
}
